import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SettingsPrivacy from "./SettingsPrivacy";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { createPortal } from "react-dom";
import axios from "axios";
export default function UserMenu({ user, onMobileNavigation, renderAfterHeader, accountMenuRef }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(0);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  
  const handleNavigation = (path) => {
    navigate(path);
    if (onMobileNavigation) {
      onMobileNavigation();
    }
  };
  
  const confirmLogout = () => {
    // Mark that the user explicitly logged out so the SSO auto-restore in
    // App.js does NOT immediately sign them back in. Cleared only when they
    // deliberately start a new "Continue with ATOZAS" login.
    if (String(process.env.REACT_APP_ATOZAS_SSO_ENABLED).toLowerCase() === "true") {
      try {
        localStorage.setItem("atozas_logged_out", "1");
      } catch (e) {
        // ignore storage errors
      }
      // Best-effort: clear the server-side ATOZAS session (fire-and-forget so
      // the UI logs out instantly and never hangs on a slow request).
      axios
        .post(
          `${process.env.REACT_APP_API_URL || ""}/auth/logout`,
          {},
          { withCredentials: true }
        )
        .catch(() => {
          // Ignore — the client-side guard above already prevents re-login.
        });
    }

    // Clear both cookie and localStorage
    Cookies.remove("user");
    localStorage.removeItem("user");
    dispatch({
      type: "LOGOUT",
    });
    setShowLogoutConfirm(false);
    navigate("/login");
  };
  return (
    <div className="mmenu">
      {visible === 0 && (
        <div>
          <div 
            className="mmenu_header hover3"
            onClick={() => handleNavigation("/profile")}
            style={{ cursor: 'pointer' }}
          >
            <img src={user?.picture} alt="" />
            <div className="mmenu_col">
              <span>
                {user?.first_name} {user?.last_name}
              </span>
              <span>See your profile</span>
            </div>
          </div>
          {renderAfterHeader && accountMenuRef && (
            <div ref={accountMenuRef}>{renderAfterHeader}</div>
          )}
          <div className="mmenu_splitter"></div>
          <div 
            className="mmenu_main hover3"
            onClick={() => handleNavigation("/about-us")}
            style={{ cursor: 'pointer' }}
          >
            <div className="small_circle">
              <i className="info_filled_icon"></i>
            </div>
            <div className="mmenu_col">
              <div className="mmenu_span1">About Us</div>
              <div className="mmenu_span2">Learn more about UsmaApp</div>
            </div>
          </div>
              <div 
                className="mmenu_main hover3"
                onClick={() => handleNavigation("/saved-publication")}
                style={{ cursor: 'pointer' }}
              >
                <div className="small_circle">
                  <i className="save_icon"></i>
                </div>
                <div className="mmenu_col">
                  <div className="mmenu_span1">Saved Publication</div>
                  <div className="mmenu_span2">View your saved publication</div>
                </div>
              </div>
              <div 
                className="mmenu_main hover3"
                onClick={() => handleNavigation("/archived-publication")}
                style={{ cursor: 'pointer' }}
              >
                <div className="small_circle">
                  <i className="archive_icon"></i>
                </div>
                <div className="mmenu_col">
                  <div className="mmenu_span1">Archived Publication</div>
                  <div className="mmenu_span2">Publication you've archived</div>
                </div>
              </div>
          <div 
            className="mmenu_main hover3"
            onClick={() => handleNavigation("/feedback")}
            style={{ cursor: 'pointer' }}
          >
            <div className="small_circle">
              <i className="report_filled_icon"></i>
            </div>
            <div className="mmenu_col">
              <div className="mmenu_span1">Give feedback</div>
              <div className="mmenu_span2">Help us improve UsmaApp</div>
            </div>
          </div>
          <div className="mmenu_splitter"></div>
          <div
            className="mmenu_item hover3"
            onClick={() => {
              handleNavigation("/settings");
            }}
          >
            <div className="small_circle">
              <i className="settings_filled_icon"></i>
            </div>
            <span>Settings & privacy</span>
            <div className="rArrow">
              <i className="right_icon"></i>
            </div>
          </div>
          {/* Help & Support removed */}
          {/* Display & Accessibility removed from user menu */}
          <div
            className="mmenu_item hover3"
            onClick={() => {
              setShowLogoutConfirm(true);
            }}
          >
            <div className="small_circle">
              <i className="logout_filled_icon"></i>
            </div>
            <span>Logout</span>
          </div>
        </div>
      )}
      {visible === 1 && <SettingsPrivacy setVisible={setVisible} />}
      {showLogoutConfirm &&
        createPortal(
          <div className="logout_confirm_overlay" onClick={() => setShowLogoutConfirm(false)}>
            <div
              className="logout_confirm_modal"
              onClick={(e) => e.stopPropagation()}
              role="dialog"
              aria-modal="true"
              aria-labelledby="logout-confirm-title"
            >
              <h3 id="logout-confirm-title">Log out?</h3>
              <p>Are you sure you want to logout?</p>
              <div className="logout_confirm_actions">
                <button
                  type="button"
                  className="logout_confirm_cancel"
                  onClick={() => setShowLogoutConfirm(false)}
                >
                  Cancel
                </button>
                <button type="button" className="logout_confirm_button" onClick={confirmLogout}>
                  Logout
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
      {/* Help & Support removed */}
  {/* DisplayAccessibility component removed from user menu */}
    </div>
  );
}
